import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
import AdminChange from "./components/AdminChange.vue";
import SubChange from "./components/SubChange.vue";
import { getMsg } from "@/utils";
export default /*#__PURE__*/ _defineComponent({
    name: 'index',
    props: {
        type: { default: "sub" },
        isCancel: { type: Boolean, default: false },
        scenario: null
    },
    emits: ["success", "cancel"],
    setup(__props, { emit }) {
        const successHandle = () => {
            getMsg("密码修改成功", "success");
            emit("success");
        };
        const cancelHandle = () => {
            emit("cancel");
        };
        return (_ctx, _cache) => {
            return (__props.type === 'sub')
                ? (_openBlock(), _createBlock(SubChange, {
                    key: 0,
                    "is-cancel": __props.isCancel,
                    onSuccess: successHandle,
                    onCancel: cancelHandle
                }, null, 8, ["is-cancel"]))
                : (_openBlock(), _createBlock(AdminChange, {
                    key: 1,
                    scenario: __props.scenario,
                    "is-cancel": __props.isCancel,
                    onSuccess: successHandle,
                    onCancel: cancelHandle
                }, null, 8, ["scenario", "is-cancel"]));
        };
    }
});
